// store/modules/low/actions.js
import LowApi from "../../../api/modules/LowApi";

export const searchLows = async ({ commit }, payload) => {
  try {
    const { context, ...data } = payload;
    return await LowApi.searchLows(context, data);
  } catch (error) {
    console.error("Error al buscar bajas:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/low/actions.js